import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAppSelector, useAppDispatch } from '../hooks';
import { Dialog } from '../components/DialogOld';
import { FormGroup } from '../components/FormGroup';
import { FormRow } from '../components/FormRow';
import { Selector } from '../components/Selector';
import { TransmitterSelector } from '../components/TransmitterSelector';
import { createPanelTransmitter } from '../actions/CreatePanelTransmitter';
import { savePanelTransmitter } from '../actions/SavePanelTransmitter';
import { deletePanelTransmitter } from '../actions/DeletePanelTransmitter';
import { hideDialog } from '../reducers/app';
import { setEditPanelTransmitterDialogDeviceID, setEditPanelTransmitterDialogOrd, setEditPanelTransmitterDialogPanelGroupID } from '../reducers/edit_panel_transmitter_dialog';
const DeleteButton = (props) => (_jsx("button", { type: "button", className: "delete lw danger", onClick: props.onClick, children: "Ta bort" }));
const CancelButton = (props) => (_jsx("button", { type: "button", className: "lw", onClick: props.onClick, children: "Avbryt" }));
const SaveButton = (props) => (_jsx("button", { type: "button", className: "save lw primary", onClick: props.onClick, children: "Spara \u00E4ndringar" }));
const CreateButton = (props) => (_jsx("button", { type: "button", className: "save lw primary", onClick: props.onClick, children: "Skapa uttag" }));
export const DialogPanelTransmitterEdit = (props) => {
    const dispatch = useAppDispatch();
    const edit_panel_transmitter_dialog = useAppSelector(state => state.edit_panel_transmitter_dialog);
    const def_panel_group = useAppSelector(state => state.definitions.panel_groups);
    const ordRaw = edit_panel_transmitter_dialog.ord;
    const ord = isNaN(ordRaw) ? null : ordRaw;
    const panel_groups = [];
    for (const pg of Object.values(def_panel_group.entities)) {
        panel_groups.push({
            value: pg.id,
            label: pg.title
        });
    }
    if (edit_panel_transmitter_dialog.device_id == undefined) {
        return null;
    }
    let footerleft, footerright;
    if (edit_panel_transmitter_dialog.panel_device_id) {
        footerleft = [
            (_jsx(DeleteButton, { onClick: () => dispatch(deletePanelTransmitter(props.panel_id)) }, "delete"))
        ];
        footerright = [
            (_jsx(CancelButton, { onClick: () => dispatch(hideDialog()) }, "cancel")),
            (_jsx(SaveButton, { onClick: () => dispatch(savePanelTransmitter(props.panel_id)) }, "save"))
        ];
    }
    else {
        footerright = [
            (_jsx(CancelButton, { onClick: () => dispatch(hideDialog()) }, "cancel")),
            (_jsx(CreateButton, { onClick: () => dispatch(createPanelTransmitter(props.panel_id)) }, "create"))
        ];
    }
    return (_jsxs(Dialog, { id: "edit-panel-transmitter", title: "Redigera panelens s\u00E4ndare", footerleft: footerleft, footerright: footerright, children: [_jsx(FormRow, { children: _jsx(FormGroup, { label: "S\u00E4ndare", children: _jsx(TransmitterSelector, { name: "transmitter", value: edit_panel_transmitter_dialog.device_id, onChange: event => dispatch(setEditPanelTransmitterDialogDeviceID(parseInt(event.target.value))) }) }) }), _jsx(FormRow, { children: _jsx(FormGroup, { label: "Grupp", children: _jsx(Selector, { name: "panel_group_id", value: edit_panel_transmitter_dialog.panel_group_id, options: panel_groups, onChange: event => dispatch(setEditPanelTransmitterDialogPanelGroupID(parseInt(event.target.value))) }) }) }), _jsx(FormRow, { children: _jsx(FormGroup, { label: "Ordning", children: _jsx("input", { type: "text", name: "ord", value: ord !== null && ord !== void 0 ? ord : '', onChange: event => dispatch(setEditPanelTransmitterDialogOrd(parseInt(event.target.value))) }) }) }), _jsx("input", { name: "panel_transmitter_id", type: "hidden", value: edit_panel_transmitter_dialog.panel_device_id == null ? '' : edit_panel_transmitter_dialog.panel_device_id })] }));
};
